import moment from 'moment'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import {exportTypes} from './Constant'
import {filterRequest as PatientFilterRequest} from './patient/Constants'

// This file is used to store the constants and utility functions for the table components
// + Key as TableType

//#region Table Types
export const tableTypes = {
    gp: 'gp',
    ecg: 'ecg',
    note: 'note',
    client: 'client',
    patient: 'patient',
    pathway: 'pathway',
    hospital: 'hospital',
    genericLog: 'genericLog',
    examination: 'examination',
    supportTeams: 'supportTeams',
    relevantContact: 'relevantContact',

    hcp: 'hcp',
    hcpRole: 'hcpRole',
    hcpPatient: 'hcpPatient',
    hcpStaticList: 'hcpStaticList',
    hcpSupportTeam: 'hcpSupportTeam',
}

export const columnsVisibilityTypes = {
    shown: 'shown',
    hidden: 'hidden',
}
//#endregion

//#region Redirect Path
export function getRedirectPath(tableType) {
    if (!tableType) {
        return ''
    }

    switch (tableType) {
        case 'patient':
            return '/patients'
        default:
            return ''
    }
}
//#endregion

//#region Columns visibility
export function storeColumnVisibility(
    shownColumns,
    hiddenColumns,
    columns,
    key,
) {
    const toSaveKey = key ? `${key}ColumnsVisibility` : ''

    if (!toSaveKey) {
        return
    }

    const columnsVisibility = columns.map(column => {
        return {
            field: column.field,
            header: column.header,
            initialShown: shownColumns.map(x => x.field).includes(column.field),
        }
    })

    localStorage.setItem(toSaveKey, JSON.stringify(columnsVisibility))
}

export function getColumnVisibility(key) {
    const toLoadKey = key ? `${key}ColumnsVisibility` : ''

    if (!toLoadKey) {
        return []
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : []
}

// Type refers to shown or hidden
export function storeColumnVisibilityByTableType(key, type, columns) {
    const toSaveKey = key ? `${key}ColumnsVisibilityType-${type}` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, JSON.stringify(columns))
}

export function getColumnVisibilityByTableType(key, type) {
    const toLoadKey = key ? `${key}ColumnsVisibilityType-${type}` : ''

    if (!toLoadKey) {
        return []
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : []
}

export function storeShouldRememberColumns(key, value) {
    const toSaveKey = key ? `${key}ShouldRememberColumns` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, value)
}

export function getShouldRememberColumns(key) {
    const toLoadKey = key ? `${key}ShouldRememberColumns` : ''

    if (!toLoadKey) {
        return false
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : false
}
//#endregion

//#region Table Advanced Filter
export function getAdvancedFilterByTableType(tableType) {
    if (!tableType) {
        return []
    }

    switch (tableType) {
        case tableTypes.patient:
            return PatientFilterRequest
        default:
            return []
    }
}

export function storeAdvancedFilter(key, value) {
    const toSaveKey = key ? `${key}AdvancedFilter` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, JSON.stringify(value))
}

export function getAdvancedFilter(key) {
    const toLoadKey = key ? `${key}AdvancedFilter` : ''

    if (!toLoadKey) {
        return {}
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : {}
}

export function storeShouldRememberAdvancedFilter(key, value) {
    const toSaveKey = key ? `${key}ShouldRememberAdvancedFilter` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, value)
}

export function getShouldRememberAdvancedFilter(key) {
    const toLoadKey = key ? `${key}ShouldRememberAdvancedFilter` : ''

    if (!toLoadKey) {
        return false
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : false
}
//#endregion

//#region Table Lock Columns or Rows
export function storeTableLock(key, value) {
    const toSaveKey = key ? `${key}TableLock` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, JSON.stringify(value))
}

export function getTableLock(key) {
    const toLoadKey = key ? `${key}TableLock` : ''

    if (!toLoadKey) {
        return {}
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : {}
}

export function storeTableLockedColumns(key, value) {
    const toSaveKey = key ? `${key}TableLockedColumns` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, JSON.stringify(value))
}

export function getTableLockedColumns(key) {
    const toLoadKey = key ? `${key}TableLockedColumns` : ''

    if (!toLoadKey) {
        return []
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : []
}

export function storeTableLockedRows(key, value) {
    const toSaveKey = key ? `${key}TableLockedRows` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, JSON.stringify(value))
}

export function getTableLockedRows(key) {
    const toLoadKey = key ? `${key}TableLockedRows` : ''

    if (!toLoadKey) {
        return []
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : []
}

export function storeShouldRememberTableLock(key, value) {
    const toSaveKey = key ? `${key}ShouldRememberTableLock` : ''

    if (!toSaveKey) {
        return
    }

    localStorage.setItem(toSaveKey, value)
}

export function getShouldRememberTableLock(key) {
    const toLoadKey = key ? `${key}ShouldRememberTableLock` : ''

    if (!toLoadKey) {
        return false
    }

    return localStorage.getItem(toLoadKey)
        ? JSON.parse(localStorage.getItem(toLoadKey))
        : false
}
//#endregion

//#region Export Data
const automaticWidthSettingExcel = data => {
    let objectMaxLength = []
    if (data?.length > 0) {
        for (let i = 0; i < data.length; i++) {
            let value = Object.values(data[i])
            let key = Object.keys(data[i])

            if (value?.length > 0) {
                for (let j = 0; j < value.length; j++) {
                    let maxLength = 10

                    if (typeof value[j] == 'number' || !value[j]) {
                        objectMaxLength[j] = key[j].length + 2 || maxLength
                    } else {
                        if (value[j]?.length >= key[j].length) {
                            maxLength = value[j]?.length
                        } else {
                            if (key[j] && convertKeyToLabel(key[j])) {
                                maxLength = convertKeyToLabel(key[j])?.length
                            }
                        }

                        if (
                            !objectMaxLength[j] ||
                            maxLength >= objectMaxLength[j]
                        ) {
                            objectMaxLength[j] = maxLength + 2
                        }
                    }
                }
            }
        }
        if (objectMaxLength?.length > 0) {
            let wscols = objectMaxLength.map(item => {
                return {width: item}
            })

            return wscols
        }

        return []
    } else {
        return []
    }
}

export const saveAsExcelOrCsvFile = (
    fileType, // csv, excel
    headerLabels, // Header Columns
    data, // List row data [{}]
    fileName,
) => {
    import('xlsx').then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet([])
        let headerText = `Exported at ${moment().toString()}`
        let headerRow = {A1: {t: 's', v: headerText}}
        Object.assign(worksheet, headerRow)
        xlsx.utils.sheet_add_aoa(worksheet, [headerLabels], {
            origin: 'A3',
        })
        xlsx.utils.sheet_add_json(worksheet, data, {
            origin: 'A4',
            skipHeader: true,
        })
        worksheet['!cols'] = automaticWidthSettingExcel(data)
        const workbook = {
            Sheets: {data: worksheet},
            SheetNames: ['data'],
        }
        const excelBuffer = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        })

        import('file-saver').then(module => {
            if (module && module.default) {
                let TYPE = ''
                if (fileType === exportTypes.csv) {
                    TYPE = 'text/csv'
                } else if (fileType === exportTypes.excel) {
                    TYPE =
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
                }
                let EXTENSION = `.${fileType}`
                const data = new Blob([excelBuffer], {
                    type: TYPE,
                })
                module.default.saveAs(
                    data,
                    fileName + '_Export_' + moment().toString() + EXTENSION,
                )
            }
        })
    })
}
//#endregion
